<template>
  <footer id="footer">
    <div class="container">
      <div class="d-flex flex-column flex-md-row">
        <div class="organizer d-flex">
          <img :src="moe" alt="教育部" class="d-none d-xl-inline" />
          <div class="d-flex flex-md-column">
            <div class="org-title me-2 me-lg-0 mb-2 mb-lg-0">主辦單位</div>
            <div class="org-name small-text">教育部</div>
          </div>
        </div>
        <div class="organizer d-flex">
          <img :src="yuntech" alt="雲林科技大學" class="d-none d-xl-inline" />
          <div class="d-flex flex-md-column">
            <div class="org-title me-2 me-lg-0 mb-2 mb-lg-0">承辦單位</div>
            <div class="org-name small-text">雲林科技大學</div>
          </div>
        </div>
        <div class="organizer d-flex">
          <img
            :src="nantech"
            alt="台南應用科技大學"
            class="d-none d-xl-inline"
          />
          <div class="d-flex flex-md-column">
            <div class="org-title me-2 me-lg-0 mb-2 mb-lg-0">協辦單位</div>
            <div class="org-name small-text">台南應用科技大學</div>
          </div>
        </div>
        <div id="contact-us" class="d-flex ms-lg-auto">
          <div class="org-name fw-bold me-2">聯絡我們</div>
          <div class="org-name">
            <div class="d-flex flex-column flex-lg-row">
              <span class="me-2">國立雲林科技大學</span>
              <span>數位媒體設計系</span>
            </div>
            <div class="d-flex flex-column flex-lg-row">
              <span class="me-2">640301 雲林縣斗六市大學路三段123號</span>
              <span>(05)5342601 # 6593</span>
            </div>
            <div class="">dmd@yuntech.edu.tw</div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import moe from '@/assets/img/moe.png';
import yuntech from '@/assets/img/yuntech.png';
import nantech from '@/assets/img/nantech.png';

export default {
  data() {
    return {
      moe,
      yuntech,
      nantech,
    };
  },
};
</script>
<style lang="stylus" scoped>
#footer
  background: $monoc4;
  color: $contract1;
  padding: 36px 0;
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 100;

.organizer
  margin-right: 24px;

  img
    margin-right: 8px;
    width: 36px;
    height: 36px;

.org-title
  font-style: normal;
  font-weight: bold;
  font-size: 9px;

@media screen and (max-width: 767.4px)
  .org-title, .org-name
    font-size: 14px !important;

  .container
    padding-left: 24px !important;
    padding-left: 24px !important;
</style>
